var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"grey-back":"","full-height":""}},[_c('dialog-form',{ref:"ref_dialogForm",attrs:{"closeDialog":_vm.fn_closeDialogForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }